import { render } from "./CardKeyword.vue?vue&type=template&id=6f71d32c&scoped=true&ts=true"
import script from "./CardKeyword.vue?vue&type=script&lang=ts"
export * from "./CardKeyword.vue?vue&type=script&lang=ts"

import exportComponent from "/root/workspace/lll-ui_hccl/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f71d32c"]])

export default __exports__